import * as React from 'react';
import { useZustand } from 'use-zustand';
import { widgetStore } from '../store';

export function BeforeAndAfter(props) {
  const {
    children
  } = props;

  const originalImage = useZustand(widgetStore, state => state.originalImageURL);
  const selectedImageURL = useZustand(widgetStore, state => state.selectedImageURL);

  return (
    <div className='before-after'>
      <div className='image-wrapper'>
        <img src={originalImage} alt="Submitted image"/>
      </div>
      <div className='image-wrapper'>
        {selectedImageURL && <img src={selectedImageURL} alt="Selected image"/>}
        {selectedImageURL && (<div>{children}</div>)}
      </div>
    </div>
  );
}
